// services/dashboardService.ts
import api from "./api";

export interface EarningsSummary {
  earnings: {
    bot_earnings: number;
    trade_earnings: number;
    referral_earnings: number;
    airdrop_earnings: number;
    total_earnings: number;
  };
  currency_conversion: {
    xrp_price_usd: number;
    bot_earnings_usd: number;
    trade_earnings_usd: number;
    referral_earnings_usd: number;
    airdrop_earnings_usd: number;
    total_earnings_usd: number;
  };
  user: {
    xrp_balance: number;
    balance_usd: number;
  };
}

export interface BotEarningsResponse {
  earnings: Array<{
    id: number;
    amount: number;
    amount_usd: number;
    type: string;
    status: string;
    created_at: string;
    metadata: any;
  }>;
  totals: {
    total_xrp: number;
    total_usd: number;
    xrp_price: number;
  };
}

const dashboardService = {
  getEarningsSummary: async (): Promise<EarningsSummary> => {
    const response = await api.get("/dashboard/earnings-summary");
    return response.data;
  },

  getBotEarnings: async (): Promise<BotEarningsResponse> => {
    const response = await api.get("/trading/bot-earnings");
    return response.data;
  },
};

export default dashboardService;
